import React from 'react';
import { useTransition } from 'react-spring';

import Toast from './Toast';

import { ToastMessage } from '../../hooks/toast';
import { Container } from './styles';

interface ToastContainerProps {
  messages: ToastMessage[];
}

const ToastContainer: React.FC<ToastContainerProps> = ({ messages }) => {
  const messagesWithTransitions = useTransition(
    messages,
    message => message.id,
    {
      from: { right: '-50%', opacity: 0 },
      enter: { right: '0%', opacity: 1 },
      leave: { right: '-50%', opacity: 0 },
    },
  );
  return (
    <Container>
      {messagesWithTransitions.map(({ key, props, item }) => {
        return <Toast key={key} message={item} style={props} />;
      })}
    </Container>
  );
};

export default ToastContainer;
